import Marquee from "react-fast-marquee";
import { Reveal, PageHeader, SectionLabel } from "@/components/Reveal";
import { CLIENTS } from "@/data/content";

const ClientGrid = () => (
  <section className="py-24 px-6 sm:px-12" data-testid="clients-grid-section">
    <div className="max-w-7xl mx-auto">
      <Reveal>
        <SectionLabel>Our Empanelled Institutions</SectionLabel>
      </Reveal>
      <div className="mt-12 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-px bg-border border border-border">
        {CLIENTS.map((c, i) => (
          <Reveal key={c.name} delay={(i % 4) * 0.05} y={16} className="bg-white">
            <div className="p-6 h-full flex flex-col gap-5 group hover:bg-ink transition-colors duration-500" data-testid={`client-card-${i}`}>
              <span className="flex h-44 items-center justify-center bg-white border border-border px-3 py-2">
                <img
                  src={c.logo}
                  alt={`${c.name} logo`}
                  className="max-h-40 w-auto max-w-full object-contain"
                  loading="lazy"
                />
              </span>
              <p className="font-serif text-sm sm:text-base font-semibold text-slate-600 group-hover:text-white transition-colors duration-500 leading-snug text-center">
                {c.name}
              </p>
            </div>
          </Reveal>
        ))}
        <Reveal delay={0.1} y={16} className="bg-ink">
          <div className="p-6 h-full flex items-center justify-center" data-testid="clients-more-card">
            <p className="font-serif text-xl sm:text-2xl font-bold text-white text-center leading-snug">
              … and adding <span className="text-gold-light">many more</span>
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);

export default function Clients() {
  return (
    <>
      <PageHeader
        label="Empanelments & Clientele"
        lines={["Trusted by 45+", "leading institutions."]}
        sub="Auric Valuation Pvt. Ltd. is empanelled with leading banks, NBFCs, housing finance companies and financial institutions across India. Our strong relationships are a testament to the trust and quality we deliver."
      />
      <section className="py-16 bg-white border-b border-border" data-testid="clients-marquee">
        <Marquee speed={30} gradient={false} pauseOnHover>
          {CLIENTS.map((c) => (
            <span key={c.name} className="mx-10 inline-flex h-28 items-center">
              <img src={c.logo} alt={`${c.name} logo`} className="max-h-24 w-auto object-contain" loading="lazy" />
            </span>
          ))}
        </Marquee>
      </section>
      <ClientGrid />
    </>
  );
}
